import React from 'react';
import { Link } from 'react-router-dom';
import { UserIcon, EnvelopeIcon, KeyIcon } from '@heroicons/react/24/outline';

const ProfilePage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-white shadow rounded-lg">
        <div className="px-6 py-5 border-b border-gray-200">
          <h2 className="text-2xl font-bold text-gray-900">Profile Settings</h2>
          <p className="mt-1 text-sm text-gray-600">Manage your account information and preferences</p>
        </div>

        <div className="px-6 py-8">
          <div className="text-center py-12">
            <UserIcon className="mx-auto h-16 w-16 text-gray-400" />
            <h3 className="mt-4 text-lg font-medium text-gray-900">Profile Management</h3>
            <p className="mt-2 text-sm text-gray-600 max-w-md mx-auto">
              Complete profile management features are coming soon. You'll be able to update your personal information,
              change your password, and manage notification preferences.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/dashboard"
                className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
              >
                <UserIcon className="h-5 w-5 mr-2" />
                Go to Dashboard
              </Link>
              <Link
                to="/reports/overview"
                className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700"
              >
                View Security Reports
              </Link>
            </div>
          </div>

          {/* Preview of future features */}
          <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-3">
            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <UserIcon className="mx-auto h-8 w-8 text-primary-600" />
              <h4 className="mt-2 text-sm font-medium text-gray-900">Personal Info</h4>
              <p className="mt-1 text-xs text-gray-500">Update name, email, and contact details</p>
            </div>
            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <KeyIcon className="mx-auto h-8 w-8 text-primary-600" />
              <h4 className="mt-2 text-sm font-medium text-gray-900">Security</h4>
              <p className="mt-1 text-xs text-gray-500">Change password and enable 2FA</p>
            </div>
            <div className="text-center p-6 bg-gray-50 rounded-lg">
              <EnvelopeIcon className="mx-auto h-8 w-8 text-primary-600" />
              <h4 className="mt-2 text-sm font-medium text-gray-900">Notifications</h4>
              <p className="mt-1 text-xs text-gray-500">Manage email and alert preferences</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
